import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useFragment } from "react-relay";

import {
  Box,
  VStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";
import { getFill } from "@whoosh/utilities/src/Cloudinary";

import { CurrentClubWeather } from "../../../components/CurrentClubWeather";
import { FacilityLogo } from "../../../features/Session/components/FacilityLogo";
import { MobileHeaderFragment_club$key } from "./__generated__/MobileHeaderFragment_club.graphql";

const HOME_IMAGE_ID = "nav-image_b4yfml.png";

type MobileHeaderProps = {
  customBG?: string;
  clubRef: MobileHeaderFragment_club$key;
};

export const MobileHeader = ({ customBG, clubRef }: MobileHeaderProps) => {
  const club = useFragment(MobileHeaderFragmentString, clubRef);
  const { top } = useSafeAreaInsets();

  const headerImage = getFill(
    customBG ? customBG : HOME_IMAGE_ID,
    1400,
    933
  )?.toURL();

  return (
    <Box
      visible={{ base: true, lg: false }}
      position="relative"
      marginBottom={2}
      testID="mobile-header"
      padding={6}
      backgroundColor="surface-primary"
      style={{ paddingTop: top || 16 }}
    >
      <Box paddingHorizontal={6} paddingTop={2}>
        <Box
          bg="surface-primary"
          borderWidth={1}
          borderColor="surface-dividers"
          borderRadius="4"
          overflow="hidden"
          style={{
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 17 },
            shadowOpacity: 0.08,
            shadowRadius: 40,
            elevation: 8,
          }}
        >
          <Image
            alt={t`decorative header`}
            source={{ uri: headerImage }}
            resizeMode="cover"
            style={{ width: "100%", height: 72 }}
          />
          <VStack alignItems="center" gap={2} paddingBottom={3}>
            <Box
              mt="-6"
              borderWidth={2}
              borderColor="surface-primary"
              borderRadius="2"
              bg="surface-primary"
            >
              <FacilityLogo
                imageProps={{
                  style: {
                    width: 48,
                    height: 48,
                    borderRadius: 8,
                  },
                }}
                clubRef={club}
              />
            </Box>
            <Box maxWidth={265} paddingHorizontal={4}>
              <Text
                variant="mainHeading"
                color="text-primary"
                textAlign="center"
              >
                {club?.name}
              </Text>
            </Box>
            <CurrentClubWeather showMinimal />
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export const MobileHeaderFragmentString = graphql`
  fragment MobileHeaderFragment_club on Club {
    ...FacilityLogoFragment_club
    name
  }
`;
